module.exports = __webpack_public_path__ + "static/media/03.Krishna Balaram-ink.642edc0e.jpeg";